import {
  GeneralExamWappGradientIcon,
  GenerativeAiWappGradientIcon,
  FormatListBulletedIcon,
  SupportIcon,
} from '@weblite/icons'
import {
  PostWappIcon,
  VoteWappIcon,
  MeetingWappIcon,
  BlogWappIcon,
  EventWappIcon,
  FormWappIcon,
  RahkarWappIcon,
  DiscussionWappIcon,
  TribuneWappIcon,
} from '$common/icons/wapps'
import { LocationIcon } from '$common/icons/location'
import { wappByIdView } from '$logic/wapps/wapps.reducer'
import { t } from '$i18n'

export const POLL_CONFIG = {
  name: t('wapps.poll'),
  color: '#FE9C2D',
  icon: <VoteWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #FF8C21 0%, #FFE040 100%)',
}

export const POST_CONFIG = {
  name: t('wapps.post'),
  color: '#F75B5C',
  icon: <PostWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #FA4545 13.4%, #F57073 86.6%)',
}

export const MEETING_CONFIG = {
  name: t('wapps.meeting'),
  color: '#52BD67',
  icon: <MeetingWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%);',
}

export const FORUM_CONFIG = {
  name: t('wapps.forum'),
  color: '#52BD67',
  icon: <DiscussionWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #96C93D 0%, #00B09B 100.48%)',
}

export const RAHKAR_CONFIG = {
  name: t('wapps.rahkar'),
  color: '#52BD67',
  icon: <RahkarWappIcon />,
  loadingGradient: '#000',
}

export const GENERAL_EXAM_CONFIG = {
  name: t('wapps.generalExam'),
  color: '#388AFA',
  icon: <GeneralExamWappGradientIcon startColor="#284FE7" endColor="#53BEFB" />,
  loadingGradient: 'linear-gradient(0deg, #0538FF 0%, #70E3F5 100%)',
}
export const GENERATIVE_AI_CONFIG = {
  name: t('wapps.generativeAI'),
  color: '#388AFA',
  icon: <GenerativeAiWappGradientIcon />,
  loadingGradient: 'linear-gradient(180deg, #9445EC 0%, #2782ED 100%)',
}

export const BLOG_CONFIG = {
  name: t('wapps.blog'),
  color: '#F75B5C',
  icon: <BlogWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
}

export const NEVISEH_CONFIG = {
  name: t('wapps.nevise'),
  color: '#F75B5C',
  icon: <BlogWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
}

export const FORM_CONFIG = {
  name: t('wapps.form'),
  color: '#FE9C2D',
  icon: <FormWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #FFE040 0%, #FF8C21 100%)',
}

export const EVENT_CONFIG = {
  name: t('wapps.event'),
  color: '#52BD67',
  icon: <EventWappIcon />,
  loadingGradient: 'linear-gradient(147.25deg, #00B09B 0.82%, #96C93D 100.82%)',
}

export const SUPPORT_CONFIG = {
  name: t('myAccount.support'),
  color: 'neutral000',
  icon: (
    <SupportIcon sx={{ color: 'neutral000', width: '65%', height: '65%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
}

export const MULTIMEDIA_CONFIG = {
  name: t('wapps.multimedia'),
  color: '#5C64ED',
  icon: <RahkarWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #9445EC 0%, #2782ED 100%)',
}

export const TRIBUNE_CONFIG = {
  name: t('wapps.tribune'),
  color: '#52BD67',
  icon: <TribuneWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
}
export const MAP_CONFIG = {
  name: t('wapps.map'),
  color: 'primary.main',
  icon: <LocationIcon sxProps={{ color: 'primary.main' }} />,
  loadingGradient: '',
}

export const PORSESH_CONFIG = {
  name: t('wapps.porsesh'),
  color: 'primary.main',
  icon: <FormatListBulletedIcon />,
  loadingGradient: 'linear-gradient(0deg, #0538FF 0%, #70E3F5 100%)',
}

const WAPP_BAR_THEME: Record<
  string,
  { name: string; color: string; icon: JSX.Element; loadingGradient: string }
> = {
  post: POST_CONFIG,
  poll: POLL_CONFIG,
  meeting: MEETING_CONFIG,
  blog: BLOG_CONFIG,
  forum: FORUM_CONFIG,
  event: EVENT_CONFIG,
  multimedia: MULTIMEDIA_CONFIG,
  form: FORM_CONFIG,
  support: SUPPORT_CONFIG,
  tribune: TRIBUNE_CONFIG,
  map: MAP_CONFIG,
  neviseh: NEVISEH_CONFIG,
  'general-exam': GENERAL_EXAM_CONFIG,
  rahkar: RAHKAR_CONFIG,
  porsesh: PORSESH_CONFIG,
}

export function getWappTheme(wappId: string) {
  const { groupName } = wappByIdView(wappId) || {}
  return (
    (groupName && WAPP_BAR_THEME[groupName]) || {
      name: t('wapps.unknown') as string,
      color: '#818181',
      icon: null,
      loadingGradient: 'unset',
    }
  )
}
